// Hinweisbalken während des kostenfreien Probezeitraums.
export function TrialBanner({ daysLeft }: { daysLeft?: number | null }) {
  const days = typeof daysLeft === "number" ? daysLeft : null;
  const restText =
    days === null ? "" : days <= 0 ? " – endet heute" : days === 1 ? " – noch 1 Tag" : ` – noch ${days} Tage`;

  return (
    <div className="w-full bg-amber-50 border-b border-amber-200 text-amber-900">
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 px-4 py-2 text-sm text-center">
        <span className="font-semibold">Probezeitraum{restText}.</span>
        <span>
          Für die Vollversion:{" "}
          <a href="tel:+4981314531860" className="font-semibold underline underline-offset-2 hover:text-amber-950">
            +49 8131 4531860
          </a>{" "}
          ·{" "}
          <a href="mailto:sonne-qm@natura-pflegehilfsmittel.de" className="font-semibold underline underline-offset-2 hover:text-amber-950">
            sonne-qm@natura-pflegehilfsmittel.de
          </a>{" "}
          (Natura Pflegehilfsmittel)
        </span>
      </div>
    </div>
  );
}
